import { useManagePageQueryParams } from '@/hooks/queryParams/useManagePageQueryParams'
import { Avatar, Flex, Text, Title } from '@collable/ui'

const ManageVideosHeader = () => {
  const { selectedChannel } = useManagePageQueryParams()
  return (
    <Flex direction="column" gap={20}>
      <Flex gap={16} alignItems="center">
        <Avatar size="xl" type="creator" src={selectedChannel?.channelThumbnail} />
        <Title size="subTitle1" color="labelStrong" fontWeight="bold" as="h1">
          {selectedChannel?.channelName || selectedChannel?.email}
        </Title>
      </Flex>
      <Flex direction="column" gap={2}>
        <Title size="subTitle1" fontWeight="bold" as="h2">
          내 영상 관리
        </Title>
        <Text size="body2" color="labelAssistive">
          영상에 광고 정보를 등록하면 대행사들이 채널을 더 빠르게 알아볼 수 있어요
        </Text>
      </Flex>
    </Flex>
  )
}

export default ManageVideosHeader
